import React, { useMemo } from 'react'
import { KeywordMatchTypes } from '../../config'
import { resolveValueAndMessage } from './StateBadge'
import { BadgeSmall, resolveStateMessage } from './SmallBadge'

export const MatchTypeSmall = ({
    matchType,
    state = '',
    parent_ad_group_status,
    parent_campaign_status,
    className,
}) => {
    const {
        letter,
        classes,
        message: typeMessage,
    } = useMemo(() => {
        switch (matchType) {
            case KeywordMatchTypes.Exact:
            case 'EXACT':
                return {
                    letter: 'E',
                    classes: 'targeting-type-badge-exact',
                    message: 'Exact match',
                }
            case KeywordMatchTypes.Phrase:
            case 'PHRASE':
                return {
                    letter: 'P',
                    classes: 'targeting-type-badge-phrase',
                    message: 'Phrase match',
                }
            case KeywordMatchTypes.Broad:
            case 'BROAD':
                return {
                    letter: 'B',
                    classes: 'targeting-type-badge-broad',
                    message: 'Broad match',
                }
            default:
                return {}
        }
    }, [matchType])

    const { value, stateMessage } = useMemo(() => {
        const raw = resolveValueAndMessage(state, parent_ad_group_status, parent_campaign_status)
        const { value, message: stateMessage } = resolveStateMessage(raw)

        return {
            value,
            stateMessage,
        }
    }, [state, parent_ad_group_status, parent_campaign_status])

    const message = useMemo(() => {
        return (
            <div>
                <div>{typeMessage}</div>
                <div>{stateMessage}</div>
            </div>
        )
    }, [typeMessage, stateMessage])

    return (
        <BadgeSmall
            className={className}
            classes={classes}
            letter={letter}
            state={value}
            message={message}
        />
    )
}
